export var DateTimeType;
(function (DateTimeType) {
    DateTimeType["date"] = "date";
    DateTimeType["time"] = "time";
})(DateTimeType || (DateTimeType = {}));
//# sourceMappingURL=DateTimeType.js.map